import { render } from "./StudentUserUpdate.vue?vue&type=template&id=58e5b8b0&scoped=true"
import script from "./StudentUserUpdate.vue?vue&type=script&lang=js"
export * from "./StudentUserUpdate.vue?vue&type=script&lang=js"

import "./StudentUserUpdate.vue?vue&type=style&index=0&id=58e5b8b0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5b8b0"]])

export default __exports__